export default __webpack_public_path__ + "static/media/BASSETS-4.d13fe314.png";